export const environment = {
  version: '1.2',
  production: false,
  env: 'QA',
  apiEndpoint: 'https://qa.paqs-proc.parxdev.net',
  authenticationService: '/api/authenticate/login',
  statusService: '/api/status',
  authToken: 'M3FiMDhmNWRwajUxcHZnNTEzYWEwYm9sNXM6MTd1NW5zNWdsajVmYjluNHVjMGFmNTJub25nbjljaTlnNTJsMml1MWJ1dTZtOGN1dWxlNA=='
};
